export function formatScore(score: number): string {
  return score.toFixed(1);
}

export function percentileLabel(score: number, allScores: number[]): string {
  if (allScores.length <= 1) return '';
  const sorted = [...allScores].sort((a, b) => b - a);
  const rank = sorted.indexOf(score);
  if (rank === -1) return '';
  // Rank-based percentile within this session's scored photos
  const pct = Math.max(1, Math.round(100 - (rank / (sorted.length - 1)) * 100));
  return `Top ${pct}% of ${sorted.length} photos scored`;
}

export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}
